import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";

import { Pill } from "./Pill";
import styles from "./TruncatingPill.module.css";

/**
 * A Pill that never overflows its column: the label is clipped with an
 * ellipsis and the full value is offered in a tooltip, but only when it is
 * actually cut off — a pill that fits gets no redundant tooltip.
 */
export const TruncatingPill = ({ value, ...pillColors }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const check = () => setIsTruncated(element.scrollWidth > element.clientWidth);
    check();

    const observer = new ResizeObserver(check);
    observer.observe(element);

    return () => observer.disconnect();
  }, [value]);

  const pill = (
    <Pill {...pillColors} className={styles.truncatingPill}>
      <span ref={textRef} className={styles.text}>
        {value}
      </span>
    </Pill>
  );

  if (!isTruncated) return pill;

  // The wrapping span gives the tooltip a layout box it can anchor to.
  return (
    <Tooltip title={value}>
      <span className={styles.tooltipAnchor}>{pill}</span>
    </Tooltip>
  );
};
